export default "__VITE_ASSET__efa99daa__"